import React from 'react'
import cs from 'classnames'
import Page from 'component/page-container'
import { nl2br } from 'helpers'
import { YMaps, Map, Placemark, ZoomControl } from 'react-yandex-maps';
// import './style.css'

/* global API */

// TODO: Добавить это в route\recommendation-route\index.js
// TODO: https://t.me/c/" + recommendation.process?.telegramChannelId в хэлпер

const Recommendation = (recommendation) => {
    const [isLiked, setIsLiked] = React.useState(recommendation.isLiked)
    const handleLike = () => {
        API.instance().recommendation.setIsLiked(recommendation.id, !isLiked ? 1 : 0).then(result => {
            if (result) {
                setIsLiked(!isLiked ? 1 : 0)
            }
        })
    }
    const date = new Date(recommendation.createdAt) > new Date(recommendation.updatedAt) ? new Date(recommendation.createdAt) : new Date(recommendation.updatedAt)
    console.log(date)
    return (
        <div className="recommendation">
            <h3 className="recommendation__title">{recommendation.title}</h3>
            <div
                className="recommendation__description"
                dangerouslySetInnerHTML={{ __html: nl2br(recommendation.description) }}
            />
            <div className="recommendation__links">
                {recommendation.linkList.map(link =>
                    <div key={link.id} className="recommendation__link">
                        <a href={link.link} target="_blank" rel="noreferrer">{link.link}</a>
                    </div>
                )}
            </div>
            {(!!recommendation.telegramChannelMessageId) && (
                <div className="container">
                    <div className="test">
                        Комментариев {recommendation.commentCounter}
                    </div>
                    <div className="test">
                        Комментарии добавляют <a
                            target="_blank"
                            rel="noreferrer"
                            href={
                                "https://t.me/c/" +
                                recommendation.process?.telegramChannelId.toString().substr(4) +
                                "/" + recommendation.telegramChannelMessageId
                            }
                        >к сообщению в Телеграме</a>.
                    </div>
                    <div className="test">
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href={`https://t.me/c/${recommendation.process?.telegramSupergroupId.toString().substr(4)}/${recommendation.telegramMessageId}`}
                        >Оригинал сообщения</a>.
                    </div>
                </div>
            )}
            {!!recommendation.location && (
                <YMaps>
                    <div className="recommendation__map">
                        <Map
                            defaultState={{
                                center: [recommendation.location.latitude, recommendation.location.longitude],
                                zoom: 15
                            }}
                            width="100%"
                            height="400px"
                        >
                            <Placemark
                                geometry={[recommendation.location.latitude, recommendation.location.longitude]}
                            />
                            <ZoomControl />
                        </Map>
                    </div>
                </YMaps>
            )}
            <div className="test">{recommendation.tag.join(', ')}</div>
            <div className="test">{recommendation.category.title}</div>
            <div className="test">
                <i
                    className={cs('fa', 'fa-heart', 'like-button', { 'like-button_liked': isLiked })}
                    onClick={handleLike}
                />
                {recommendation.likeCounter}
            </div>
        </div>
    )
}

const UserRoute = props => {
    console.log()
    const [recommendations, setRecommendations] = React.useState([])
    React.useEffect(() => {
        (async () => {
            setRecommendations(await API.instance().recommendation.getByUser(props.match.params.name))
        })()
    }, [])

    return (
        <Page className="user-list-page" h1={props.match.params.name}>
            <div className="page__inner">
                <h2>Рекомендации</h2>
                <div className="test">
                    {recommendations.map(item => (
                        <Recommendation
                            key={item.id}
                            {...item}
                        />
                    ))}
                </div>
            </div>
        </Page>
    )
}

export default UserRoute
